import { istek } from './istemci';
import type { Semalar } from './sema';
import type { Kimlik } from './tipler';

/**
 * ORGANİZASYON VE PERSONEL UÇLARI.
 *
 * Tipler `schema.d.ts`ten TÜRETİLİR; elle yazılmaz.
 */

export type OperasyonTipi = Semalar['BirimOzetiDto']['operasyonTipi'];
export type DevamYontemi = Semalar['PersonelOzetiDto']['devamYontemi'];

export type BirimOzeti = Semalar['BirimOzetiDto'];
export type PersonelOzeti = Semalar['PersonelOzetiDto'];
export type PersonelSayfasi = Semalar['PersonelSayfasiDto'];

/** Ağaç düğümü. `altBirimler` şemada özyineli üretiliyor; sarmalayıcı gerekmiyor. */
export type BirimDugumu = Semalar['BirimDugumuDto'];

/** İstemci tarafı sorgu şekli — hiçbir DTO'nun karşılığı değildir. */
export interface PersonelFiltresi {
  arama?: string;
  birimId?: Kimlik;
  /** true = çalışanlar, false = ayrılmışlar, boş = hepsi. */
  calisiyorMu?: boolean;
  sayfa?: number;
  sayfaBoyutu?: number;
}

/* ------------------------------------------------------------------ */

export function birimAgaci(kapaliDahil = false): Promise<BirimDugumu[]> {
  return istek<BirimDugumu[]>('/v1/organizasyon/birim-agaci', {
    sorgu: { kapaliDahil: kapaliDahil ? 'true' : undefined },
  });
}

export function birimListesi(kapaliDahil = false): Promise<BirimOzeti[]> {
  return istek<BirimOzeti[]>('/v1/organizasyon/birim', {
    sorgu: { kapaliDahil: kapaliDahil ? 'true' : undefined },
  });
}

export function personelListesi(filtre: PersonelFiltresi): Promise<PersonelSayfasi> {
  return istek<PersonelSayfasi>('/v1/personel', {
    sorgu: {
      arama: filtre.arama,
      birimId: filtre.birimId,
      calisiyorMu: filtre.calisiyorMu,
      sayfa: filtre.sayfa,
      sayfaBoyutu: filtre.sayfaBoyutu,
    },
  });
}

export function personelKarti(personelId: Kimlik): Promise<PersonelOzeti> {
  return istek<PersonelOzeti>(`/v1/personel/${personelId}`);
}
